<template>
    <div class="live-dental-advisory-container" id="live-dental-advisory">
        <section class="container">
            <div class="row-custom">
                <div class="team-col">
                    <h1>Mondhygiëne</h1>
                    <p>
                        Een goede mondhygiëne is de basis voor een gezond gebit. Onze mondhygiënist helpt u met grondige gebitsreiniging en verwijderen tandplak en tandsteen op plekken waar u zelf moeilijk bij kunt. Tijdens uw afspraak geven we advies over de juiste mondverzorgingsproducten en technieken. Met regelmatige behandelingen en de juiste zorg thuis, blijft uw mond gezond en fris.
                    </p>
                    <!-- <a href="" class="hero-btn red-btn">Steun ons</a> -->
                </div>
                <div class="team-col image-col-right">
                    <img src="../assets/images/preventative-dental-care.jpg" id="the-practice-img">
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "LiveDentalAdvisory",
    mounted() {
        const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden')
      hiddenElements.forEach((el) => observer.observe(el))
    }
}
</script>

<style scoped>
.hidden-first {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 1.5s;
}
.show-first {
  opacity: 1;
  transform: translateX(0);
}
.team-col {
    flex-basis: 48%;
}
.row-custom .image-col-right{
  display: flex;
  justify-content: center;
}

.row-custom {
    margin-bottom: 0px;
}
.team-col img {
    width: 100%;
    max-width: 600px;
}
.team-col h1 {
    padding-top: 0;
}
.team-col p {
    padding: 15px 0 0;
    font-size: 1.4rem;
}

#the-practice-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
#the-practice-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
}

.oral-hygiene-experts-container {
    padding: 4rem 0;
}


@media(max-width: 991px) {
    .row-custom {
        margin-bottom: 20px;
    }
    .row-custom {
        flex-direction: column;
    }
    h1 {
        font-size: 20px;
        text-align: center;
    }

    .team-col img {
        max-width: 100%;
    }

    .team-col p {
        padding: 7px 0px 0px;
    }

    #the-practice-img {
        height: 200px;
    }

}
</style>